import React from 'react';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';
import { FieldPath, FieldValues } from 'react-hook-form';
import { Checkbox, Text } from '@cad-arc';
import { mapInputSizeToCommonSize } from './utils';

type CheckboxProps = React.ComponentProps<typeof Checkbox>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    checkboxProps?: Partial<CheckboxProps>;
};

export const FormCheckbox = function FormCheckbox<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { checkboxProps, label, ...integratedFormControlProps } = props;
    const checkboxPropsMemo = React.useMemo(() => checkboxProps ?? {}, [checkboxProps]);
    const renderViewMode = React.useCallback((value: unknown) => {
        if (!value) return <Text>No</Text>;
        return <Text>Yes</Text>;
    }, []);
    return (
        <IntegratedFormControl<unknown>
            {...integratedFormControlProps}
            renderViewMode={renderViewMode}
            showLabel={false} // If showLabel is true, a small amount of extra height is added to the checkbox container and ruins alignment
        >
            {(providedProps) => (
                <Checkbox
                    {...mapInputSizeToCommonSize(providedProps)}
                    {...checkboxPropsMemo}
                    value={providedProps.value ? 'true' : 'false'}
                    isChecked={providedProps.value}
                >
                    {label}
                </Checkbox>
            )}
        </IntegratedFormControl>
    );
};
